import React, { useState, useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Loading from "../../../common/Loading";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CKEditor from "ckeditor4-react";
import Grid from "@material-ui/core/Grid";

import Button from "components/CustomButtons/Button";

import { actionCreators as actionCreatorsAdmin } from "../../../../_actions/adminActions";

const useStyles = makeStyles(theme => ({
  marginBottom: {
    marginBottom: theme.spacing(3)
  },
  formLabel: {
    display: "block",
    width: "12rem"
  },
  dialogActions: {
    justifyContent: "center"
  }
}));

const ManageMailingAddressDialog = ({
  open,
  onClose,
  getMailingAddress,
  updateMailingAddress,
  mailingAddress,
  isFetching,
  isFetched,
  isUpdating
}) => {
  const classes = useStyles();
  const [isDirty, setDirty] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  const handleEditorChange = useCallback(evt => {
    setEditorData(evt.editor.getData());
  }, []);

  const [editorData, setEditorData] = useState(mailingAddress);

  useEffect(() => {
    getMailingAddress();
    setDirty(false);
  }, []);

  useEffect(() => {
    setEditorData(mailingAddress);
  }, [mailingAddress]);

  useEffect(() => {
    if (open) {
      setDirty(false);
    }
  }, [open]);

  useEffect(() => {
    if (isUpdating.MAILING_ADDRESS) {
      onClose();
    }
  }, [isUpdating]);

  const handleSave = () => {
    setDirty(true);
    setIsSaved(true);
    updateMailingAddress({ value: editorData });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="paper"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Mailing Address</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid
              container
              justify="center"
              alignItems="center"
              spacing={2}
              style={{ marginBottom: "20px" }}
            >
              {!isFetched.MAILING_ADDRESS &&
              isFetching.MAILING_ADDRESS &&
              !isSaved &&
              !isDirty ? (
                <Loading />
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container justify="center" alignItems="center" spacing={2}>
              <CKEditor data={editorData} onChange={handleEditorChange} />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActions }}>
        {isDirty ? (
          <Loading />
        ) : (
          <>
            <Button color="success" variant="contained" onClick={handleSave}>
              OK
            </Button>
            <Button color="danger" variant="contained" onClick={onClose}>
              Cancel
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = state => ({
  mailingAddress: state.adminReducer.mailingAddress,
  isFetching: state.adminReducer.isFetching,
  isFetched: state.adminReducer.isFetched,
  isUpdating: state.adminReducer.isUpdating
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...actionCreatorsAdmin }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageMailingAddressDialog);
